import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { LoginFlowPage } from './login-flow';

@NgModule({
  declarations: [LoginFlowPage],
  imports: [IonicPageModule.forChild(LoginFlowPage)],
  exports: [LoginFlowPage],
})
export class LoginFlowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/flows/login-flow/login-flow.module.ts